import { document } from 'global';
export function getImageDimensions(domImageHeight: number, domImageWidth: number, stageWidth: number, stageHeight: number): [number, number] {
  let canvasImageWidth, canvasImageHeight;
  // For center aligning the image.
  let ratio;
  if (domImageWidth > domImageHeight) {
    ratio = domImageWidth / domImageHeight;
    canvasImageWidth = stageWidth - 20;
    canvasImageHeight = canvasImageWidth / ratio;
  } else {
    ratio = domImageHeight / domImageWidth;
    canvasImageHeight = stageHeight - 20;
    canvasImageWidth = canvasImageHeight / ratio;
  }
  return [canvasImageWidth, canvasImageHeight];
}
export function downloadFromUrl(url: string) {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', '');
  a.setAttribute('target', '_blank');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}